// Client-side CSV download for Explore-stats supporting tables.
// Stats responses are already aggregated, so we build the CSV from
// { columns, rows } in the browser (no server round-trip needed).

function escapeCell(value) {
  const s = value === null || value === undefined ? '' : String(value);
  if (/[",\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function downloadCSV(filename, columns, rows) {
  const header = columns.map(escapeCell).join(',');
  const body = (rows || [])
    .map((row) => columns.map((col) => escapeCell(row[col])).join(','))
    .join('\n');
  const csv = `${header}\n${body}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
